module.exports = __webpack_public_path__ + "static/media/Javascript_Badge.c65bbbe1.png";